import { useAppSelector } from "src/redux/hooks";

/**
 * Warehouse-locking for the current staff member. Tenant admins always get
 * a free choice; a non-admin staff member with a warehouse assigned on
 * their profile has warehouse-picking fields (Sale, Purchase, Stock
 * Adjustment, Transfers, Reports, ...) locked to it. A non-admin with no
 * warehouse assigned is left unrestricted — this is an opt-in assignment,
 * not a requirement, so an unassigned staff member keeps today's free
 * choice rather than being blocked until an admin sets one.
 */
const useAssignedWarehouse = () => {
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);

  const isTenantAdmin =
    user?.role === "admin" || user?.roleDetails?.name?.toLowerCase() === "admin";

  const assignedWarehouseId = !isTenantAdmin
    ? user?.warehouseId || user?.warehouseDetails?._id || null
    : null;

  return {
    isTenantAdmin,
    assignedWarehouseId,
    isWarehouseLocked: !!assignedWarehouseId,
  };
};

export default useAssignedWarehouse;
